export enum ProductValue {
  BUDSIE = "1",
  SELFIE = "2",
  BULK_SAMPLE = "3",
  SPECIALITY_COMMISSION = "4",
  PETSIE_CAT = "5",
  PETSIE_DOG = "6",
  PETSIE_OTHER = "7",
  IMAGINABLE = "8",
  HUGGABLES_CAT = "9",
  HUGGABLES_DOG = "10",
  HUGGABLES_OTHER = "11",
  FOREVERS_CAT = "12",
  FOREVERS_DOG = "13",
  FOREVERS_OTHER = "14",
  WAGGABLES_DOG = "15",
  PILLOW = "16",
  PILLOW_BULK_SAMPLE = "17",
  PRINTED_SOCKS = "18",
  BUDSIES_PALS = "19",
  BUDDY_PILLOW = "20",
  PHRASE_PILLOW = "21",
}
